import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, first, map, of, switchMap, timeout } from 'rxjs';
import { HttpClientWrapper } from '../../http-client-wrapper';
import { selectSelectedCompany } from '../store/auth.selectors';
import { permissionCheckUrl } from '../utility/auth.urls';

export function hasPermissions(...permissions: string[]): CanActivateFn {
  return route => {
    const httpClient = inject(HttpClientWrapper);
    const snackBar = inject(MatSnackBar);
    const router = inject(Router);
    const store = inject(Store);

    return store.select(selectSelectedCompany).pipe(
      first(company => !!company),
      switchMap(() =>
        httpClient.get<{ allowed: boolean }>(permissionCheckUrl, { p: permissions }).pipe(
          timeout({
            each: 5000,
            with: () => {
              throw Error('Service Unresponsive. Please, try again later');
            },
          }),
          map(response => {
            if (!response.allowed) {
              snackBar.open(
                'Insufficient permission. Ask your Admin for access to this resource',
                'Dismiss',
                {
                  duration: 5000,
                }
              );
              return false;
            }

            return response.allowed;
          }),
          catchError(error => {
            console.error(error);
            return of(router.createUrlTree([route.url.join('/'), 'error', '500']));
          })
        )
      )
    );
  };
}
